const $ = require('jquery');

const textFieldsInit = function () {
  $('.mtui-text-field__input').change(function () {
    if (!$(this).hasClass('date-input')) {
      $(this)
        .closest('.mtui-text-field__wrapper')
        .toggleClass('mtui-text-field_filled', $(this).val().length > 0);
    }
  });
  $('.mtui-text-field__input').each(function () {
    if (!$(this).hasClass('date-input')) {
      $(this)
        .closest('.mtui-text-field__wrapper')
        .toggleClass('mtui-text-field_filled', $(this).val().length > 0);
    }
  });
  const phoneInput = $('#booking-user-phone');
  phoneInput.click(function () {
    $(this).closest('.mtui-text-field__wrapper').addClass('mtui-text-field_filled');
    $(this).closest('.mtui-text-field__wrapper').find('.mtui-text-field__floating-label').removeClass('phone_label');
  });

  phoneInput.change(function () {
    if ($(this).val().length > 0) {
      $(this).closest('.mtui-text-field__wrapper').addClass('mtui-text-field_filled');
      $(this).closest('.mtui-text-field__wrapper').find('.mtui-text-field__floating-label').removeClass('phone_label');
    } else {
      $(this).closest('.mtui-text-field__wrapper').removeClass('mtui-text-field_filled');
      $(this).closest('.mtui-text-field__wrapper').find('.mtui-text-field__floating-label').addClass('phone_label');
      $(this).attr('placeholder', '');
    }
  });
  if (phoneInput.val()?.length > 0) {
    phoneInput.closest('.mtui-text-field__wrapper').addClass('mtui-text-field_filled');
    phoneInput.closest('.mtui-text-field__wrapper').find('.mtui-text-field__floating-label').removeClass('phone_label');
  } else {
    phoneInput.closest('.mtui-text-field__wrapper').removeClass('mtui-text-field_filled');
    phoneInput.closest('.mtui-text-field__wrapper').find('.mtui-text-field__floating-label').addClass('phone_label');
  }
  $('.iti__selected-flag').on('click', function () {
    $('#iti-0__country-listbox').on('click', 'li', function () {
      phoneInput.closest('.mtui-text-field__wrapper').addClass('mtui-text-field_filled');
      phoneInput
        .closest('.mtui-text-field__wrapper')
        .find('.mtui-text-field__floating-label')
        .removeClass('phone_label');
    });
  });

  $('.password-visible').on('click', function () {
    const input = $(this).siblings('input');
    const eyeOpen = $(this).find('#eye-open');
    const eyeClosed = $(this).find('#eye-closed');

    if (input.attr('type') === 'password') {
      input.attr('type', 'text');
      eyeOpen.hide();
      eyeClosed.show()
    } else {
      input.attr('type', 'password');
      eyeOpen.show();
      eyeClosed.hide();
    }
  });
};

export { textFieldsInit };
